export const normalizePromocodesResponse = (promoCodes) => {
  return promoCodes.data.promo_codes.map((promo) => {
    if (promo.website === '') {
      promo.website = 'playosmo';
    }
    return promo;
  });
};
